import classnames from 'classnames';
import React from 'react';
import PropTypes from 'prop-types';

/**
 * Simple, standard icon wrapper component.
 */
export const Icon = ({ name, color, className, ...props }) => {
  const classes = classnames(
    'icon',
    `icon-${name}`,
    color ? `icon--${color}` : null,
    className,
  );
  return <i className={classes} {...props} />;
};

Icon.propTypes = {
  name: PropTypes.string.isRequired,
  color: PropTypes.oneOf(['yellow', 'red', 'grey', 'green', 'blue', 'purple']),
  className: PropTypes.string,
};

/**
 * Wrapper component for a simple, standard icon with a tooltip that appears on hover.
 */
export const IconWithTooltip = ({
  name,
  tooltip,
  className,
  direction = 'top',
  ...props
}) => (
  <span
    className={classnames('tooltip', { [`tooltip--${direction}`]: direction, className })}
    aria-label={tooltip}
  >
    <Icon name={name} {...props} />
  </span>
);

IconWithTooltip.propTypes = {
  ...Icon.propTypes,
  tooltip: PropTypes.string.isRequired,
  direction: PropTypes.oneOf(['top', 'bottom', 'left', 'right']),
};
